// Module
var code = "<div ui-grid=\"$ctrl.gridOptions\" class=\"omc-grid params-grid\" ui-grid-edit ui-grid-resize-columns></div>";
// Exports
module.exports = code;